import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'

const AccountVerificationBanner = ({ currentUser, locationPathName }) => {
  const pathMatches = locationPathName.match(/\/my\/(listings|inbox)/)
  const verificationStatus = get(
    currentUser,
    'payout_account.verification_status'
  )
  const shouldShow = pathMatches && verificationStatus === 'unverified'
  if (!shouldShow) return null
  return (
    <div className="alerts-wrapper">
      <div className="container-flexible alerts alert-warning">
        <div className="row">
          <div className="col-md-12 alert alert-dismissible" role="alert">
            <span>
              Stripe requires additional information to verify your payout
              account.{' '}
              <a href="/my/account/payout-account">Verify your account now.</a>
            </span>
            <button
              className="close"
              aria-label="Close"
              data-dismiss="alert"
              type="button"
            >
              <span className="icon icon-close" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(({ auth: { currentUser }, router }) => ({
  currentUser,
  locationPathName: router.location.pathname,
}))(AccountVerificationBanner)
